import React from 'react'
import { PageHead } from '@fs/zion-head'
import { useTranslation } from 'react-i18next'
import { usePageView } from '@fs/zion-analytics'
import { useAamState, useAamDispatch, useAamGuestInitialization, ACTIONS } from '../state/AamStore'
import Accessibility from '../../../shared/components/Accessibility'
import AAMContent from './AAMContent'
import useDSApplicationMode from '../../../shared/hooks/useDSApplicationMode'
import { setSessionStorageItem } from '../../../shared/helpers/sessionStorage'
import getCanonicalUrl from '../../../shared/helpers/canonicalUrl'

export default function AAMGuestMain({ nonstandardUser }) {
  const { t } = useTranslation()
  const initData = { page_detail: 'All About Me - Guest' }
  usePageView(initData)
  const aamDispatch = useAamDispatch()
  const appState = useAamState()
  const appMode = useDSApplicationMode()
  const toggleAccessibity = (access) => {
    aamDispatch({ type: ACTIONS.STATE_UPDATE, key: 'isAccessible', data: !access })
  }
  setSessionStorageItem({ redirectToGuestPage: false })
  useAamGuestInitialization(nonstandardUser, appState) // Using effective user vs user to support helper mode)
  return (
    <>
      <PageHead
        omitSiteName
        title={t('landing-page.aam.seo-title', 'All About Me: Your birth year was a vibe—relive it!')}
        url={getCanonicalUrl()}
      />
      {appMode === 'STATION' && <Accessibility onClick={toggleAccessibity} pullDown />}
      <AAMContent tileData={appState.tileData} year={appState.year} />
    </>
  )
}
